// Human-readable role badges for a host. A host runs agents ("Computer"),
// drives screens ("Display server"), or both (docs/household-display-plan.md §1,
// §11). A blank/legacy/undefined roles value reads as agent — the whole existing
// fleet is agent hosts.
export function hostRoleLabels(roles?: string[]): string[] {
  const set = new Set(roles && roles.length ? roles : ['agent'])
  const out: string[] = []
  if (set.has('agent')) out.push('Computer')
  if (set.has('display')) out.push('Display server')
  return out.length ? out : ['Computer']
}

// hostRunsAgents reports whether a host carries the agent role (blank/undefined =
// agent, matching the server). Used to filter the agent-create picker so a
// display-only box is never offered as a place to run an agent — the server
// rejects it anyway, but the picker shouldn't show it.
export function hostRunsAgents(roles?: string[]): boolean {
  return new Set(roles && roles.length ? roles : ['agent']).has('agent')
}
